module.exports = __webpack_public_path__ + "static/image_COBRA-d9f3608069cfa5a345a355df9e60014f.jpg";